// utils/houseNav.js
// Single source of truth for "The House" feature navigation.
//
// Shared by HouseSidebar (HouseOnly accounts), the main Sidebar (SharedHouse /
// HouseOnly blocks) and the house dashboard shortcut picker. Keeping one list
// here prevents the routes from drifting apart — the Sidebar copies previously
// pointed at the legacy Blazor paths (/settings, /tasks, …) which 404 in Next.
import {
    FaCog, FaListAlt, FaFilePdf, FaInfoCircle, FaWallet, FaPhone, FaCalendarAlt,
} from 'react-icons/fa'

export const HOUSE_NAV_ITEMS = [
    { href: '/house/settings',       label: 'Info & Access',        iconPath: 'global/houseinfo.png',      icon: FaCog },
    { href: '/house/tasks',          label: 'Duties & Assignments', iconPath: 'global/houseduties.png',    icon: FaListAlt },
    { href: '/house/sop',            label: 'SOP',                  iconPath: 'global/housesop.png',       icon: FaFilePdf },
    { href: '/house/emergencyinfo',  label: 'Emergency Info File',  iconPath: 'global/houseeif.png',       icon: FaInfoCircle },
    { href: '/house/housedues',      label: 'House Dues',           iconPath: 'global/housedues.png',      icon: FaWallet },
    { href: '/house/houseneeds',     label: 'House Needs',          iconPath: 'global/houseneeds.png',     icon: FaListAlt },
    { href: '/house/emsneeds',       label: 'EMS Needs',            iconPath: 'global/houseeneeds.png',    icon: FaListAlt },
    { href: '/house/warehouseneeds', label: 'Warehouse Needs',      iconPath: 'global/housewneeds.png',    icon: FaListAlt },
    { href: '/house/messages',       label: 'House Message Board',  iconPath: 'global/housemessages.png',  icon: FaListAlt },
    // lacffassn only — matches the legacy FireHouseMenu gating. The house-only
    // menu had a /whiteboardhouse link, but that page was never built.
    { href: '/house/whiteboard',     label: 'Whiteboard',           iconPath: 'global/whiteboard.png',     icon: FaListAlt, lacOnly: true },
    { href: '/house/stationroster',  label: 'Station Roster',       iconPath: 'global/houserotations.png', icon: FaListAlt, lacOnly: true },
    { href: '/house/votes',          label: 'Votes',                iconPath: 'global/housevotes.png',     icon: FaListAlt },
    { href: '/house/phonebook',      label: 'Phonebook',            iconPath: 'global/housephonebook.png', icon: FaPhone },
    { href: '/house/rotations',      label: 'Duty Rotations',       iconPath: 'global/houserotations.png', icon: FaCalendarAlt },
    { href: '/house/other',          label: 'Other',                iconPath: 'global/houseother.png',     icon: FaListAlt },
]

// Items flagged `lacOnly` only appear for the LA County association org.
export function houseNavItemsFor(orgId) {
    return HOUSE_NAV_ITEMS.filter(i => !i.lacOnly || orgId === 'lacffassn')
}
